import { linko } from "@shared/linko";
import type {
  StatisticsGroupInsightsQueryBody,
  StatisticsGroupInsightsResult,
} from "./types";

type StatisticsQueriesGroupInsights = {
  getGroupInsights: (
    body: StatisticsGroupInsightsQueryBody,
  ) => Promise<{ data: StatisticsGroupInsightsResult }>;
};

export async function fetchStatisticsGroupInsights(
  body: StatisticsGroupInsightsQueryBody,
): Promise<StatisticsGroupInsightsResult> {
  const queries = linko.statistics
    .queries as unknown as StatisticsQueriesGroupInsights;
  const { data } = await queries.getGroupInsights(body);
  return data;
}
